<template>
  <section>
    <b-field>
      <b-upload v-model="file" :loading="loading" @input="input">
        <slot v-if="$slots.default" />
        <a v-else class="button">
          <b-icon icon="upload mx-3" />
          <span>{{ $t("fileUpload") }}</span>
        </a>
      </b-upload>
    </b-field>
  </section>
</template>

<script>
import { storage } from "@/firebase";
import { v4 } from "uuid";

export default {
  name: "UploadFile",
  data() {
    return {
      file: null,
      loading: false,
    };
  },
  methods: {
    async input() {
      this.loading = true;
      if (this.file) {
        console.log(this.file.name);
        let ref = storage
          .refFromURL("gs://travio-user_uploads/")
          .child(`user_uploads/${this.$store.getters.getCurrentUser.uid}/${v4()}/${this.file.name}`);
        await ref.put(this.file);
        let url = await ref.getDownloadURL();
        this.$emit("fileUploaded", {
          name: this.file.name,
          type: this.file.type,
          url,
        });
        this.fill = null;
      }
      this.loading = false;
    },
  },
};
</script>
